<template>
  <div>
    <div class="section">
      <div class="container">
        <!-- Page Header -->
        <div class="mb-md">
          <div class="columns is-vcentered">
            <div class="column is-one-third">
              <breadcrumbs :history="breadcrumbs.history" :current="breadcrumbs.current" />
            </div>
            <div class="column is-one-third">
              <h1 class="has-text-centered is-size-4">{{ app.platform }} Settings</h1>
            </div>
          </div>
        </div>
        <!-- Info -->
        <div v-if="!loading && account !== null" class="border-b mb-xl pb-xl">
          <StoreDetails :account="account" />
        </div>
        <!-- Receive Orders (Merchants) -->
        <div v-if="!loading && account !== null && context.isMerchant()" class="border-b mb-xl pb-xl">
          <ReceiveOrders :account="account" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ReceiveOrders from '../components/Fabric/ReceiveOrders'
import StoreDetails from '../components/Fabric/StoreDetails'
export default {
  components: {
    ReceiveOrders,
    StoreDetails
  },
  data () {
    return {
      loading: true,
      account: null
    }
  },
  computed: {
    ...mapGetters(['app', 'auth', 'context']),
    breadcrumbs () {
      return {
        current: (this.loading) ? 'Loading...' : this.app.platform,
        history: [
          { label: 'Settings', name: 'settings' },
          { label: 'Integrations', name: 'settings.integrations' }
        ]
      }
    },
    endpoint () {
      return this.context.route + '/platform-accounts/' + this.$route.params.id + '/'
    }
  },
  methods: {
    load (refresh = false) {
      this.loading = (!refresh)
      this.$http.get(this.endpoint).then(response => {
        this.account = response.data
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.load()
  },
  props: []
}
</script>
